// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2VvMq","sendOtp":"AuthorizeToLogin_sendOtp__3QH-E"};